
<div mat-dialog-title>
	<span class="card-title-block card-title-block-adjusted dialog-content-margin copo-title" translate>
		new.offer.request.message
	</span>

	<button type="button" mat-icon-button class="close-button"
		mat-dialog-close>
		<mat-icon class="button-close" color="accent" svgIcon="md:close"></mat-icon>
	</button>
</div>

<div mat-dialog-actions>
	<button type="button" mat-stroked-button [mat-dialog-close]="true" 
		class="copo-dialog-button-margin" 
		tabindex="-1"  (click)="setOfferType('spot')">
		<span translate> offer.type.yes </span>
	</button>
	<button type="button" mat-stroked-button [mat-dialog-close]="true" 
		class="copo-dialog-button-margin copo-button"
		tabindex="-1"  (click)="setOfferType('framework')">
			<span translate> offer.type.no </span>
	</button>
</div>